import { useEffect, useState } from "react"

const ReceivedOfferCounter = ({ cost, nextStep, closeWindow, counterData, setCounterData }) => {

  const {amount, days, hours} = counterData;
  const [isSubmitDisabled, setIsSubmitDisabled] = useState();

  const onInputHandler = (e, max) => {
    const { name, value } = e.target;

    let cleanedValue = value.replace(/[^0-9.,]/g, '');

    if (name === 'amount') {
      const decimalParts = cleanedValue.split(/[,\.]/);
      if (decimalParts.length > 2 || (decimalParts.length === 2 && decimalParts[1].length > 2)) {
        return;
      }
    }


    if (cleanedValue === '') {
      setCounterData((prevData) => ({
        ...prevData,
        [name]: null
      }));
      return;
    }

    const numericValue = Number(cleanedValue.replace(',', '.'));

    if (numericValue > max) {
      setCounterData((prevData) => ({
        ...prevData,
        [name]: max
      }));
      return;
    }


    setCounterData((prevData) => ({
      ...prevData,
      [name]: numericValue
    }));
  };

const isDisabledSubmitCheck = () => {
  setIsSubmitDisabled(
    (amount === null || amount === 0)
    ||
    (
      (days !== null || days !== 0) && hours === null
    )
    ||
    (
      (hours !== null || hours !== 0) && days === null
    )
    ||
    (days === 0 && hours === 0)
  );
};

useEffect(() => {
  isDisabledSubmitCheck()
}, [counterData])

  return (
    <div className='make-offer__container'>
      <p className="make-offer__balance">
        <span>Amount Offered</span>
        <b>${cost} USD</b>
      </p>
      <div className="make-offer__form-row">
        <label>Your offer</label>
        <p className="make-offer__input-wrapper">
          <input type="number" name='amount' onInput={onInputHandler} placeholder="Offer value"  value={amount} />
          <span>USD</span>
        </p>
      </div>
      <div className="make-offer__form-row make-offer__form-row--double">
        <label>Offer valid for</label>
        <p className="make-offer__input-wrapper">
          <input type="number" name="days" onInput={onInputHandler} placeholder="1-30" value={days} />
          <span>DAYS</span>
        </p>
        <p className="make-offer__input-wrapper">
          <input type="number" name="hours" onInput={onInputHandler} placeholder="1-23" value={hours} />
          <span>HOURS</span>
        </p>
      </div>
      <footer className="sell-card__info-offer-options">
        <button onClick={closeWindow}>Cancel</button>
        <button className='accept' disabled={isSubmitDisabled} onClick={() => nextStep('confirm-counter')}>Continue</button>
      </footer>
    </div>
  )
}

export default ReceivedOfferCounter;
